var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxEnvelope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33594H3.33332C2.41416 3.33594 1.66666 4.08344 1.66666 5.0026V15.0026C1.66666 15.9218 2.41416 16.6693 3.33332 16.6693H16.6667C17.5858 16.6693 18.3333 15.9218 18.3333 15.0026V5.0026C18.3333 4.08344 17.5858 3.33594 16.6667 3.33594ZM16.6667 5.0026V5.42844L9.99999 10.6143L3.33332 5.42927V5.0026H16.6667ZM3.33332 15.0026V7.53927L9.48832 12.3268C9.63425 12.4414 9.81443 12.5037 9.99999 12.5037C10.1855 12.5037 10.3657 12.4414 10.5117 12.3268L16.6667 7.53927L16.6683 15.0026H3.33332Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxEnvelope);
export default __webpack_public_path__ + "static/media/bx-envelope.98d7ae6217c21deae842f687faa4bfc1.svg";
export { ForwardRef as ReactComponent };